import { render, staticRenderFns } from "./GroupTeaser.vue?vue&type=template&id=01bd7362&"
import script from "./GroupTeaser.vue?vue&type=script&lang=js&"
export * from "./GroupTeaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports